<template>
  <v-row class="pa-2 pa-md-12">
    <v-col cols="12" md="10" class="mx-auto">
      <p class="display-1 font-weight-bold primary--text mb-8">
        {{ organism.id ? "Editar especie" : "Nueva especie" }}
      </p>
      <v-card>
        <v-stepper v-model="stepperActiveTab">
          <v-stepper-header dark>
            <v-stepper-step :complete="stepperActiveTab > 1" step="1" editable
              >Paso 1</v-stepper-step
            >

            <v-divider></v-divider>
            <v-stepper-step :complete="stepperActiveTab > 2" step="2" editable
              >Paso 2</v-stepper-step
            >
            <v-divider></v-divider>

            <v-stepper-step step="3" editable>Paso 3</v-stepper-step>
          </v-stepper-header>

          <v-stepper-items>
            <v-stepper-content step="1">
              <p class="title primary--text font-weight-bold">
                {{ attachementLength }} Imágenes
              </p>

              <v-card outlined>
                <OrganismGallery
                  :organism-id="organism.id"
                  v-if="organism.id"
                  :editable="true"
                  v-on:lengthUpdated="
                    length => (this.attachementLength = length)
                  "
                ></OrganismGallery>
              </v-card>

              <p class="title primary--text font-weight-bold pt-4">Taxonomía</p>

              <v-text-field
                v-model="organism.className"
                label="Clase"
                outlined
                rounded
              ></v-text-field>
              <v-text-field
                v-model="organism.order"
                label="Orden"
                outlined
                rounded
              ></v-text-field>
              <v-text-field
                v-model="organism.family"
                label="Familia"
                outlined
                rounded
              ></v-text-field>
              <v-text-field
                v-model="organism.scientificName"
                label="Nombre Científico"
                outlined
                rounded
              ></v-text-field>
              <v-text-field
                v-model="organism.vernacularName"
                label="Nombre Común"
                outlined
                rounded
              ></v-text-field>

              <v-divider class="mb-4 primary"></v-divider>
              <div class="d-flex pb-2">
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="stepperActiveTab = 2" rounded
                  >Continuar</v-btn
                >
              </div>
            </v-stepper-content>

            <v-stepper-content step="2">
              <p class="title primary--text font-weight-bold">
                Métrica general
              </p>
              <v-text-field
                v-model="organism.LT_max"
                label="LT máx. (cm)"
                outlined
                rounded
              ></v-text-field>
              <v-text-field
                v-model="organism.LT_mid"
                label="LT medio (cm)"
                outlined
                rounded
              ></v-text-field>
              <v-text-field
                v-model="organism.depth_range"
                label="Distribución batimétrica (m)"
                outlined
                rounded
              ></v-text-field>

              <p class="body-1 primary--text font-weight-medium pt-4">
                Talla de madurez (TPMS)
              </p>
              <vue-editor
                v-model="organism.TPMS_field"
                :editorToolbar="customToolbar"
              ></vue-editor>

              <v-divider class="mb-4 primary"></v-divider>
              <div class="d-flex pb-2">
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="stepperActiveTab = 3" rounded
                  >Continuar</v-btn
                >
              </div>
            </v-stepper-content>

            <v-stepper-content step="3">
              <p class="title primary--text font-weight-bold">
                Recomendaciones para su captura
              </p>

              <v-text-field
                v-model="organism.N_max"
                label="N° máximo de ejemplares"
                outlined
                rounded
              ></v-text-field>
              <v-text-field
                v-model="organism.W_min"
                label="Peso mínimo por ejemplar"
                outlined
                rounded
              ></v-text-field>
              <v-text-field
                v-model="organism.veda"
                label="Veda reproductiva (entre meses)"
                outlined
                rounded
              ></v-text-field>

              <v-divider class="mb-6 primary"></v-divider>

              <p class="title primary--text font-weight-bold">
                Biología y ecología
              </p>

              <p class="body-1 primary--text font-weight-medium">
                Distribución en Chile
              </p>
              <vue-editor
                v-model="organism.locality_CL"
                :editorToolbar="customToolbar"
              ></vue-editor>

              <p class="body-1 primary--text font-weight-medium pt-4">
                Hábitat
              </p>
              <vue-editor
                v-model="organism.habitat"
                :editorToolbar="customToolbar"
              ></vue-editor>

              <p class="body-1 primary--text font-weight-medium pt-4">
                Biologia y ecología
              </p>
              <vue-editor
                v-model="organism.biology"
                :editorToolbar="customToolbar"
              ></vue-editor>

              <v-divider class="mb-6 mt-6 primary"></v-divider>

              <p class="title primary--text font-weight-bold">
                Pesquerías y estado de conservación
              </p>

              <p class="body-1 primary--text font-weight-medium">Pesquería</p>
              <vue-editor
                v-model="organism.fisheries"
                :editorToolbar="customToolbar"
              ></vue-editor>

              <p class="body-1 primary--text font-weight-medium pt-4">
                Estado de conservación
              </p>
              <vue-editor
                v-model="organism.conservation"
                :editorToolbar="customToolbar"
              ></vue-editor>

              <v-divider class="mb-6 mt-6 primary"></v-divider>

              <p class="title primary--text font-weight-bold">Referencias</p>

              <p class="body-1 primary--text font-weight-medium pt-4">
                Referencias
              </p>
              <vue-editor
                v-model="organism.references"
                :editorToolbar="customToolbar"
              ></vue-editor>

              <p class="body-1 primary--text font-weight-medium pt-4">
                Autor ficha
              </p>
              <vue-editor
                v-model="organism.card_author"
                :editorToolbar="customToolbar"
              ></vue-editor>

              <v-divider class="primary mt-6 mb-6"></v-divider>
              <p class="title primary--text font-weight-bold">Otros</p>
              <v-checkbox
                v-model="organism.validated"
                label="Especie validada"
              ></v-checkbox>
              <v-divider></v-divider>
              <v-checkbox
                v-model="organism.sp_card"
                label="¿Mostrar en biblioteca?"
              ></v-checkbox>
              <v-divider></v-divider>
              <div class="pt-3 pb-3" v-if="organism.id">
                <v-btn
                  color="primary"
                  @click="removeOrganismDialog = true"
                  rounded
                  width="200"
                  >Eliminar</v-btn
                >
              </div>
              <v-divider v-if="organism.id"></v-divider>
              <div class="d-flex mt-4 pb-2">
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="save" rounded>Guardar</v-btn>
              </div>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-card>

      <v-dialog v-model="removeOrganismDialog" max-width="500">
        <v-card>
          <v-card-text class="pt-7">
            <div v-if="removeOrganismStatus === 'confirm'">
              <p class="title">
                ¿Estás seguro de eliminar esta especie?
              </p>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn @click="removeOrganism" width="200" color="primary"
                  >Eliminar especie</v-btn
                >
              </v-card-actions>
            </div>
            <div v-if="removeOrganismStatus === 'loading'">
              <p class="title mb-4 mt-4">
                Eliminando especie...
              </p>
            </div>
            <div
              class="d-flex flex-column align-items-center pa-4"
              v-if="removeOrganismStatus === 'error'"
            >
              <sweetalert-icon icon="error" />
              <p class="font-weight-medium text-center title">
                Ha ocurrido un error actualizando la especie
              </p>
            </div>
            <div
              class="d-flex flex-column align-items-center pa-4"
              v-if="removeOrganismStatus === 'success'"
            >
              <sweetalert-icon icon="success" />
              <p class="font-weight-medium text-center title">
                Especie actualizada correctamente
              </p>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogSuccess" max-width="500">
        <v-card>
          <div class="d-flex flex-column align-items-center pa-4">
            <sweetalert-icon icon="success" />
            <p class="font-weight-medium text-center title">
              Especie actualizada correctamente
            </p>
          </div>
        </v-card>
      </v-dialog>
    </v-col>
  </v-row>
</template>

<script>
import OrganismGallery from "./OrganismGallery";
import { VueEditor } from "vue2-editor";
export default {
  components: { OrganismGallery, VueEditor },
  props: [],
  data: () => ({
    attachementLength: null,
    removeOrganismStatus: "confirm",
    customToolbar: [
      [{ header: [false, 1, 2, 3, 4, 5, 6] }],
      ["bold", "italic", "underline", "strike"],
      [
        { align: "" },
        { align: "center" },
        { align: "right" },
        { align: "justify" }
      ],
      [{ list: "ordered" }, { list: "bullet" }],
      [{ indent: "-1" }, { indent: "+1" }]
    ],
    organism: {},
    stepperActiveTab: 1,
    removeOrganismDialog: false,
    currFiles: [],
    files: [],
    dialogSuccess: false
  }),
  methods: {
    remove(index) {
      this.files.splice(index, 1);
    },
    async removeOrganism() {
      try {
        this.removeOrganismStatus = "loading";
        await this.$http.patch("organism/" + this.organism.id, {
          deleted: true
        });
        this.removeOrganismStatus = "success";
        this.$router.push("/costa-pez/administrador/especies");
      } catch (err) {
        this.removeOrganismStatus = "error";
      }
    },
    inputChanged() {
      console.log(this.files);
      this.files = [...this.currFiles, ...this.files];
    },
    async save() {
      this.$emit("submitted");
      if (this.organism.id) {
        try {
          await this.$http.patch("organism/" + this.organism.id, {
            ...this.organism,
            attachementList: undefined
          });
          this.dialogSuccess = true;
        } catch (err) {
          console.log(err);
        }
      } else {
        try {
          let { data: created } = await this.$http.post(
            "organism",
            this.organism
          );
          this.organism.id = created.id;
          this.dialogSuccess = true;
        } catch (err) {
          console.log(err);
        }
      }

      for (let attachement of this.organism.attachementList || []) {
        if (attachement.id) {
        } else {
          await this.$http.post("attachement", {
            archive: (attachement.archive || {}).id,
            organism: this.organism.id,
            type: "organismProfile"
          });
        }
      }
    }
  },
  computed: {},
  async mounted() {
    try {
      let idOrganism = this.$route.params.id;
      if (idOrganism) {
        let { data: organism } = await this.$http.get("organism/" + idOrganism);
        this.organism = organism;
      }
    } catch (err) {}
  }
};
</script>

<style></style>
